import {Component, Input, OnInit} from "@angular/core";
import {AgentBrandingUtils} from "fello-common";

@Component({
  selector: "app-offer-flow-easy-link",
  templateUrl: "./offer-flow-easy-link.component.html",
  styleUrls: ["./offer-flow-easy-link.component.scss"]
})
export class OfferFlowEasyLinkComponent implements OnInit {
  @Input() website: string;

  get websiteURLValue(): string {
    return AgentBrandingUtils.getAgencyWebsiteDisplayText(this.website);
  }

  constructor() {}

  ngOnInit(): void {}
}
